module.exports = __webpack_public_path__ + "static/img/3.0f8f5797.png";